/**
 * 配置编译环境和线上环境之间的切换
 */


let GIFT_PARAMS = {
  price: {":ge": 0}
}

let TARGET_PARAMS = {
  tags: {":eq": "总站"}
}

let TARGET_PARAMS_LOCK = {
  tags: {":eq": "总站"}
};

let TARGET_CREATE = {
  tags: ["总站"]
};

let SOCK_HREF = "wss://link.lemonvc.com/";

//线上是否打开测试
let openTest = sessionStorage.getItem("openTest");

if(process.env.NODE_ENV == 'production' && !openTest){
  GIFT_PARAMS = {
    price: {":ge": 1}
  };

  TARGET_PARAMS = {
    tags: {"eq": "总站", ":ni": ["测试"]}
  };

  TARGET_PARAMS_LOCK = {
    tags: {"eq": "总站", ":ni": ["测试"]}
  };

  TARGET_CREATE = {
    tags: ["总站"]
  }
}

let BOOST = 1000; //当boost值为多少的时候，档案模糊处理

export{
  GIFT_PARAMS,
  TARGET_PARAMS,
  TARGET_PARAMS_LOCK,
  TARGET_CREATE,
  SOCK_HREF,
  BOOST
}



// WEBPACK FOOTER //
// ./src/config/env.js